import React from "react";
import { BrowserRouter, Route, Routes, Navigate } from "react-router-dom";
import ProtectedRoute from '../components/protectedRoute';
import ConfirmDialog from '../components/confirm-modal';

import LogIn from "../layout/login";
import ForgotPassword from "../layout/forgotPassword";
import ResetPassword from "../layout/resetPassword";
import VerifyEmail from "../layout/verifyEmail";
import AcceptInvite from "../layout/acceptInvite";
import SuperAdmin from "../layout/superAdmin";
import Dashboard from "../layout/dashboard";
import Project from "../layout/project";
import Accessmanagement from "../layout/accessManagement";
import AnypointDetails from "../layout/anypointDetails";
import AwsDetails from "../layout/awsDetails";
import Templates from "../layout/templates";
import TemplateDescription from "../layout/templateDescription";
import MultiProjectDetails from "../layout/multiProjectDetails";
import Deployment from "../layout/deployment";
import IntegrationAgent from "../layout/integrationAgent";
import DesignAgent from "../layout/designAgent";
import MigrationAgent from "../layout/migrationAgent";
import AIDashboard from "../layout/aiDashboard";
import MuleUpgradeAgent from "../layout/muleUpgradeAgent";
import PolicyUpgradeAgent from "../layout/policyUpgradeAgent";
import UpgradeAndPolicyAgent from "../layout/upgradeAndPolicyAgent";
import SmartHub from "../layout/smartHubNew";
import TenantAdmin from "../layout/tenantAdmin";
import Features from "../layout/features";
import CloudAccounts from "../layout/cloudAccounts";

function Routing() {
  return (
    <BrowserRouter>
      <ConfirmDialog />
      <div className="routes">
        <Routes>
          {/* Public routes */}
          <Route exact path="/" element={<LogIn />} />
          <Route exact path="/forgot-password" element={<ForgotPassword />} />
          <Route exact path="/reset-password/:token" element={<ResetPassword />} />
          <Route exact path="/verify-email/:token" element={<VerifyEmail />} />
          <Route exact path="/accept-invite/:token" element={<AcceptInvite />} />

          {/* Protected routes - Basic authentication */}
          <Route 
            exact 
            path="/dashboard" 
            element={
              <ProtectedRoute>
                <Dashboard />
              </ProtectedRoute>
            } 
          />
          
          <Route 
            exact 
            path="/projectDetails/:projName/:projId" 
            element={
              <ProtectedRoute requiredPermission="projectCenter">
                <MultiProjectDetails />
              </ProtectedRoute>
            } 
          />
          
          <Route 
            exact 
            path="/templateDescription/:templateName" 
            element={
              <ProtectedRoute requiredPermission="templates">
                <TemplateDescription />
              </ProtectedRoute>
            } 
          />
          
          <Route 
            exact 
            path="/settings" 
            element={
              <ProtectedRoute>
                <Accessmanagement />
              </ProtectedRoute>
            } 
          />
          
          <Route 
            exact 
            path="/anypoint/:orgid/:anypointId" 
            element={
              <ProtectedRoute requiredPermission="connectedApps">
                <AnypointDetails />
              </ProtectedRoute>
            } 
          />
          
          <Route 
            exact 
            path="/aws/:awsId" 
            element={
              <ProtectedRoute requiredPermission="connectedApps">
                <AwsDetails />
              </ProtectedRoute>
            } 
          />
          
          {/* <Route 
            exact 
            path="/templates" 
            element={
              <ProtectedRoute requiredPermission="templates">
                <Templates />
              </ProtectedRoute>
            } 
          /> */}
          
          <Route 
            exact 
            path="/deployment/:projName/:projId" 
            element={
              <ProtectedRoute>
                <Deployment />
              </ProtectedRoute>
            } 
          />
          
          {/* AI Agent Hub Routes - Permission Protected */}
          {/* <Route 
            exact 
            path="/designAgent/:projName/:projId" 
            element={
              <ProtectedRoute requiredPermission="designAgent">
                <DesignAgent />
              </ProtectedRoute>
            } 
          /> */}
          
          {/* <Route 
            exact 
            path="/migrationAgent/:projName/:projId" 
            element={
              <ProtectedRoute requiredPermission="migrationAgent">
                <MigrationAgent />
              </ProtectedRoute>
            } 
          /> */}
          
          {/* <Route 
            exact 
            path="/AIAgentHub/migrationAgent/:projName/:projId" 
            element={
              <ProtectedRoute requiredPermission="migrationAgent">
                <MigrationAgent />
              </ProtectedRoute>
            } 
          /> */}
          
          {/* <Route 
            exact 
            path="/AIAgentHub/designAgent/:projName/:projId" 
            element={
              <ProtectedRoute requiredPermission="designAgent">
                <DesignAgent />
              </ProtectedRoute>
            } 
          /> */}
          
          {/* <Route 
            exact 
            path="/AIAgentHub/integrationAgent/:projName/:projId" 
            element={
              <ProtectedRoute requiredPermission="integrationAgent">
                <IntegrationAgent />
              </ProtectedRoute>
            } 
          /> */}
          
          <Route 
            exact 
            path="/AIAgentHub/dashboard" 
            element={
              <ProtectedRoute>
                <AIDashboard />
              </ProtectedRoute>
            } 
          />
          
          <Route
            exact
            path="/AIAgentHub/UpgradeAgent"
            element={
              <ProtectedRoute requiredPermission="upgradeAgent">
                <UpgradeAndPolicyAgent />
              </ProtectedRoute>
            }
          />

           <Route
            exact
            path="/AIAgentHub/SmartHub"
            element={
              <ProtectedRoute requiredPermission={["smartHub", "greenfieldAgent", "brownfieldAgent", "migrationAgent", "migrationDotnet", "migrationJitterbit"]}>
                <SmartHub />
              </ProtectedRoute>
            }
          />
          <Route
            exact
            path="/AIAgentHub/SmartHub/:projName/:projId"
            element={
              <ProtectedRoute requiredPermission={["smartHub", "greenfieldAgent", "brownfieldAgent", "migrationAgent", "migrationDotnet", "migrationJitterbit"]}>
                <SmartHub />
              </ProtectedRoute>
            }
          />
          
          {/* <Route
            exact
            path="/AIAgentHub/policyUpgradeAgent"
            element={
                <PolicyUpgradeAgent />
            }
          /> */}

          <Route
            exact
            path="/tenantAdmin"
            element={
              <ProtectedRoute requiredPermission="tenantAdmin">
                <TenantAdmin />
              </ProtectedRoute>
            }
          />
          <Route
            exact
            path="/superAdmin"
            element={
              <ProtectedRoute requiredPermission="superAdmin">
                <SuperAdmin />
              </ProtectedRoute>
            }
          />
          {/* Cloud Accounts — AWS onboarding (tenant admins) */}
          <Route
            exact
            path="/settings/cloud-accounts/aws"
            element={
              <ProtectedRoute requiredPermission="tenantAdmin">
                <CloudAccounts />
              </ProtectedRoute>
            }
          />
          {/* Features / Product Overview — any authenticated user */}
          <Route
            exact
            path="/features"
            element={
              <ProtectedRoute>
                <Features />
              </ProtectedRoute>
            }
          />
          {/* Catch-all — redirect unknown routes to login */}
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </div>
    </BrowserRouter>
  );
}

export default Routing;